
<template>
    <div>
        
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.association', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title ml-3">
                    <router-link :to="{ name: 'add-association' }" v-if="can || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>
                <b-container class="container-fluid mt-1">
                    <b-row >
                        <b-col col sm="12">
                                    <section class="container" id="appointment-table">
                                        <div class="appointment-table-header my-2 mb-4">
                                            <div class="row">
                                                <div class="col-12">
                                                    <b-input-group
                                                            class="mb-3"
                                                    >
                                                        <b-form-input
                                                                type="text"
                                                                class="p-2"
                                                                :placeholder="$t('message.search') + '...'"
                                                                v-model.lazy="filterCriteria"
                                                        ></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button
                                                                    size="sm"
                                                                    text="Button"
                                                                    variant="primary"
                                                                    @click="handlerOnFilterButton"
                                                            >
                                                                Go
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-3">
                                                    <div class="ml-1">
                                                        <div class="d-flex">
                                                            <b-form-select
                                                                    class="d-inline-block mr-2"
                                                                    v-model="sortSelected"
                                                                    size="sm"
                                                                    :options="sortOptions"></b-form-select>

                                                            <div>
                                                                <b-button-group size="sm" class="mr-1">
                                                                    <b-button
                                                                            :disabled="sortDirection === 'asc'"
                                                                            class="btn"
                                                                            size="sm"
                                                                            @click="sortDirection='asc'"
                                                                    >
                                                                        <i class="fa fa-sort-amount-up-alt"></i>
                                                                    </b-button>
                                                                    <b-button
                                                                            :disabled="sortDirection === 'desc'"
                                                                            class="btn"
                                                                            size="sm"
                                                                            @click="sortDirection='desc'"
                                                                    >
                                                                        <i class="fa fa-sort-amount-down-alt"></i>
                                                                    </b-button>
                                                                </b-button-group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="paginationObject.numOfPages > 1" class="col-3 pagination-wrapper d-inline-block">
                                <div class="pagination">
                                    <a
                                        href="#"
                                        :class="'prev page-numbers ' + (
                                                                    paginationObject.currentPageNumber === 1
                                                                        ? 'pagination-disabled'
                                                                        : ''
                                                                    )"
                                        @click="_handlePaginationClick('prev')"
                                    >
                                    <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                    </a>
                                    <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                    <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                                        <span
                                                                            :key="key"
                                                                            aria-current="page"
                                                                            class="page-numbers current"
                                                                        >
                                                                            {{ pageNumber }}
                                                                        </span>
                                    </template>
                                    <template v-else>
                                        <a
                                            href="#"
                                            :key="key"
                                            class="page-numbers"
                                            @click="_handlePaginationClick(pageNumber)"
                                        >
                                        {{ pageNumber }}
                                        </a>
                                    </template>
                                    </template>
                                    <a
                                        href="#"
                                        class="next page-numbers"
                                        :class="'next page-numbers ' + (
                                                                    paginationObject.currentPageNumber === paginationObject.numOfPages
                                                                        ? 'pagination-disabled'
                                                                        : ''
                                                                    )"
                                        @click="_handlePaginationClick('next')"
                                    >
                                    <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                    </a>
                                </div>
                                </div>
                                            </div>

                                        </div>

                                        <div class="row appointment-table-content">
                                            <div class="container-fluid">
                                                <template
                                                        v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0"
                                                >
                                                    <div
                                                            v-for="(mAssociation, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                            :key="key"
                                                            class="row appointment-item hovered"
                                                            @click="mAssociationClick(mAssociation.slug)"
                                                    >
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $tc('message.region', 1) }}
                                                                </span>
                                                            <h4 class="appointment-date">{{ mAssociation.region }}</h4>
                                                        </div>
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.cities') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mAssociation.ville }}
                                                            </h4>
                                                        </div>
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.address') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mAssociation.localisation }}
                                                            </h4>
                                                        </div>
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.email') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mAssociation.email }}
                                                            </h4>
                                                        </div>
                                                         <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.association') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mAssociation.nom }}
                                                            </h4>
                                                        </div>
                                                        <div class="col-lg-3">
                                                                <span class="appointment-label">
                                                                    {{ $t('message.phoneNumber') }}
                                                                </span>
                                                            <h4 class="appointment-hour">
                                                                {{ mAssociation.telephone }}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                                </template>

                                            </div>
                                        </div>
                                    </section>
                             
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';
    import { ModelSelect } from 'vue-search-select';
    import Swal from 'sweetalert2';
    import {pagination, handlePaginationClick, paginationDataProperty} from "../../helpers/paginations2";
    export default {
        name: "Associations",

        computed: {
            ...mapGetters(["Associations",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole', 'hasPraticienRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            

            rows: function() {
                
                return this.mAssociations.length;
            },
            
            /*options:function(){
                let oArray = [];

                _.forEach(this.mInstitutions, function (institution) {
                    oArray.push({value:institution.etablissementId, text:  institution.responsable});
                })  ;
                oArray.push({value:'0',text:'All'});
                return oArray;
            },**/
        },
        
        components: {
            ModelSelect
        },
        watch:{

            searchTerm:function (newValue, oldValue) {
                if(typeof(newValue) != 'undefined'){
                        if (newValue.trim().length ==0){
                        this.associationPeInstitutionsRowsFilter = [];
                    } else{
                    this.associationPeInstitutionsRowsFilter = this.mAssociations;
                    }
                }
            },

             mAssociations: function (newValue, oldValue) {
                this.paginationObject = this.Pagination(newValue, 10);
                if (!this.shouldDisplay) {
					this.currentAssociationArray = [];
					this.currentAssociationArrayFiltered = [];
				} else {
					this.currentAssociationArray = [...this.mAssociations];
					this.currentAssociationArrayFiltered = this.currentAssociationArray;
				}
                },

			// Associations: function (newValue, oldValue) {
			// 	if (!this.shouldDisplay) {
			// 		this.currentAssociationArray = [];
			// 		this.currentAssociationArrayFiltered = [];
			// 	} else {
			// 		this.currentAssociationArray = this.mAssociations();
			// 		this.currentAssociationArrayFiltered = this.currentAssociationArray;
			// 	}
			// },

			currentAssociationArray: function (newValue, oldValue) {
                // console.log("on est ici mtnt?");
				this.paginationObject = pagination(newValue);
                // console.log(this.paginationObject);
			},

			filterCriteria: async function (newValue, oldValue) {
                // console.log("filterCriteria");
                if (newValue.length !== 0) {
                    await this.getAssociations();
                    // console.log(this.Associations);
					if(!this.shouldDisplay){
                        // console.log("shouldDisplay");
                        this.shouldDisplay = true;
                    }

					    
                    // else{
                        this.currentAssociationArray = this.mAssociations();
					    this.currentAssociationArrayFiltered = this.currentAssociationArray;
                    // }
					this.handleFilter(newValue);
				} else this.shouldDisplay = false;
               // this.handleFilter(newValue);
            },

			sortDirection: function (newValue, oldValue) {
                
                                if (newValue.length !== 0) {
					this.shouldDisplay = true;
					this.handleSort(this.sortSelected ,newValue);
				} else this.shouldDisplay = false;
			},

			sortSelected: function (newValue, oldValue) {
               
                if (newValue.length !== 0) {
					this.shouldDisplay = true;
					 this.handleSort(newValue, this.sortDirection);
				} else this.shouldDisplay = false;
			},

			shouldDisplay: function (newValue, oldValue) {
                // console.log("ici m")
				if (newValue) {
					this.currentAssociationArray = this.mAssociations();
					this.currentAssociationArrayFiltered = this.currentAssociationArray;
				} else {
					this.currentAssociationArray = [];
					this.currentAssociationArrayFiltered = [];
                }
                
			}
        },
        data() {
            return {
                ...paginationDataProperty(this.$i18n),
                filterCriteria: '',
				shouldDisplay: false,
                sortDirection: 'asc',
                sortSelected: null,
                mAssociationsFilter:[],
                searchTerm : '',
                // paginationObject: {},

                item: {
                    value: '',
                    text: ''
                },

                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                sort: {
                    enabled: true,
                    initialSortBy: {field: 'region', type: 'desc'}
                },
                sortOptions: [
                    { value: null, text: this.$i18n.t('message.sortBy'), disabled: true },
                    { value: 'region', text: this.$i18n.tc('message.region', 1) },
                    { value: 'ville', text: this.$i18n.tc('message.cities',1) },
                    { value: 'responsable', text: this.$i18n.t('message.personContact') },
                    { value: 'nom', text: this.$i18n.t('message.association') },
                ],
                enabled: {enabled: true},
                            
                mAssociationsColumns: [
                    {
                        field: 'region',
                        label: this.$i18n.t('message.region'),
                    },
                    {
                        field: 'ville',
                        label: this.$i18n.tc('message.cities',1),
                    },
                    {
                        field: 'responsable',
                        label: this.$i18n.t('message.personContact'),
                    },
                    {
                        field: 'localisation',
                        label: this.$i18n.t('message.address'),
                    },
                    {
                        field: 'telephone',
                        label: this.$i18n.t('message.phoneNumber'),
                    },
                                        {
                        field: 'email',
                        label: this.$i18n.t('message.email'),
                    },
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.association'),
                    },
                ],
                offset: 0,
                limit: -1,
            }
            
        },

        methods: {
            mAssociations() {
                let pArray = [];
                // console.log("construction");
                //  console.log(this.Associations);
                _.forEach(_.orderBy(this.Associations,['created_at'],['desc']), function(association) {
                    let p = {};
                    
                    if(!_.isNull(association )){
                        p.region =  (association.region).toUpperCase();
                        p.email = association.email;
                        p.telephone = association.telephone;
                        p.slug = association.slug;
                        p.responsable = association.responsable;
                        p.ville = association.ville;
                        p.nom = association.nom;
                        p.localisation = association.localisation;
                    }
                    pArray.push(p);
                });
                
                
                return _.sortBy(pArray,['region']);
            },

            hasValue(item){
                    if(typeof(item) != 'undefined')
                    return item.length > 0;
                    return false;
            },

            

    loadForm() {
        // console.log("on est ici d'abord?");
                // console.log(this.shouldDisplay);
        // this.paginationObject = this.Pagination(newValue, 10);
        if (!this.shouldDisplay) {
		    this.currentAssociationArray = [];
			this.currentAssociationArrayFiltered = [];
		} else {
			this.currentAssociationArray = [...this.mAssociations];
			this.currentAssociationArrayFiltered = this.currentAssociationArray;
		}
    },

            async getAssociations() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                await this.$store.dispatch('getAssociations', { args : args });
            },
            notEmpty(item){
                // console.log(item.length);
                return item.length > 0;
            },
            mAssociationClick(slug) {
                this.$router.push({ name: 'association', params: { association: slug } });
            },

            deleteAssociation(association) {
                let self = this;

                let args = {
                    association: association
                };

                let successMessage = this.$i18n.t('message.associationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteAssociation', { args, index: association, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + association);
                    });
            },
        
			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
			},
            // handlePaginationClick(action, paginationObject) {
            //     // If we want to go to the previous page
            //     if (action === 'prev') {
            //         if (paginationObject.currentPageNumber - 1 >= 1)
            //             paginationObject.currentPageNumber = paginationObject.currentPageNumber - 1;
            //     }

            //     // If we want to go to the next page
            //     else if (action === 'next') {
            //         if (paginationObject.currentPageNumber + 1 <= paginationObject.numOfPages)
            //             paginationObject.currentPageNumber = paginationObject.currentPageNumber + 1;
            //     }

            //     // If we want to go to a particular page
            //     else {
            //         const numberOfPageToGoTo = Number(action);
            //         if (numberOfPageToGoTo <= paginationObject.numOfPages &&
            //             numberOfPageToGoTo >= 1
            //         ) paginationObject.currentPageNumber = numberOfPageToGoTo;
            //     }

            //     return paginationObject;
            // },
			handleFilter(value) {
                // console.log("value");
                // console.log(value);
                // const pArray=this.mAssociations();
				if (value) {
                    // console.log("filtrer");
                    // console.log(this.currentAssociationArray);
					const newCurrentAssociationArray = this.currentAssociationArray.filter(app => {
						let result = false;

						if (app.nom) {
							result = result || app.nom.toString().toLowerCase().includes(value.toLowerCase());
						}

						if (app.ville) {
							result = result || app.ville.toString().toLowerCase().includes(value.toLowerCase());
						}

						if (app.region) {
							result = result || app.region.toString().toLowerCase().includes(value.toLowerCase());
						}

						if (app.email) {
							result = result || app.email.toLowerCase().includes(value.toLowerCase());
						}

						return result;
					});
                    // console.log(newCurrentAssociationArray);
					this.currentAssociationArrayFiltered = newCurrentAssociationArray;
					this.paginationObject = pagination(newCurrentAssociationArray);
                    // console.log('pagination');
                    // console.log(this.paginationObject);
				} else {
					
					this.paginationObject = pagination(this.currentAssociationArray,2);
				}
			},

			handleSort(value, sortDirection = 'asc') {
				if (value) {
                   
	     			let newCurrentAssociationArray = [];
					const sortType = ['responsable', 'region', 'ville', 'email'];
					const restOfType = sortType.filter(i => i !== value);
                    
					const sortDirectionType = ['asc', 'desc'];
					const restOfSortDirectionType = sortDirectionType.filter(i => i !== sortDirection);

					newCurrentAssociationArray = _.orderBy(this.mAssociations, [value, ...restOfType], [sortDirection, ...restOfSortDirectionType]);
                    // console.log(newCurrentAssociationArray);
					this.paginationObject = this.Pagination(newCurrentAssociationArray,2);
				} else {
					this.paginationObject = this.Pagination(this.mAssociations,2);
                }
            }
			},
            mounted() {
                // console.log(_.isEmpty(this.paginationObject));
                this.loadForm();
                // Fetch association list
                // this.getAssociations();
            }
    }
</script>

<style scoped>

</style>